import React, {PropTypes} from 'react';
import CalendarRecommendations from './CalendarRecommendations';
import CalendarTemperatures from './CalendarTemperatures';
import CalendarPrecipitations from './CalendarPrecipitations';
import SelectionAdd from '../containers/SelectionAdd';

class Infobox extends React.Component {

  constructor () {
    super();
  }

  componentDidMount () {
    $(".btn").mouseup(function(){
      $(this).blur();
    });
  }

  componentDidUpdate () {

  }

  render() {
    let areas = this.props.data;
    let selection = this.props.selection.area_ids;
    let calendarsArray = [];
    let showDetails = 'selection-container';

    // Hide the selection panel if it should not be displayed
    if(!this.props.selection.displayed) {
      showDetails = 'hide selection-container';
    }

    for(let i=0; i<selection.length; i++) {
      let areaId = selection[i];
      let index = i + 1;

      let calendar_recommendations = (
        <div key={'r' + areaId}>
          <CalendarRecommendations
            recommended={areas[areaId]['recommended']}
            size="small"
            currentMonth={this.props.selection.currentMonth}
            width="100%"
          />
        </div>
      );

      let calendar_temperatures = (
        <div key={'t' + areaId}>
          <CalendarTemperatures
            temperatures={areas[areaId]['temperatures']}
            size="small"
            currentMonth={this.props.selection.currentMonth}
            width="100%"
          />
        </div>
      );

      let calendar_precipitations = (
        <div key={'p' + areaId}>
          <CalendarPrecipitations
            precipitations={areas[areaId]['precipitations']}
            size="small"
            currentMonth={this.props.selection.currentMonth}
            width="100%"
          />
        </div>
      );

      // Hide the unwanted graphes
      if (!this.props.options.display_recommended) calendar_recommendations = '' ;
      if (!this.props.options.display_temperatures) calendar_temperatures = '';
      if (!this.props.options.display_precipitations) calendar_precipitations = '';

      calendarsArray.push(
        <div key={areaId}>
          <h4 className="title">
            {index}. { areas[areaId]['name'] } &nbsp; <SelectionAdd areaId={areaId} />
          </h4>
          {calendar_recommendations}
          {calendar_temperatures}
          {calendar_precipitations}
          <br/>
        </div>
      );
    }

    return (
      <div className={showDetails} >
        <div className="selection">
          <h3 className="selection-title hidden-xs">Your selection &nbsp;</h3>
          <h3 className="selection-title hidden-sm hidden-md hidden-lg">Selection &nbsp;</h3>
          <a className="btn btn-default btn-xs" data-toggle="modal" data-target="#options">
            Show / hide data
          </a>
          &nbsp;
          <a className="btn btn-default btn-xs" onClick={this.props.selectionActions.removeAllAreasFromSelection}>
            Remove all
          </a>

          <div className="close-button" onClick={this.props.selectionActions.hideSelection}>
            <svg width="18px" height="17px" viewBox="0 0 18 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
              <g id="icon-close" fill="#FFFFFF">
                <polygon id="close" points="8.29289322 8.5 0.868272016 15.9246212 1.5753788 16.631728 9 9.20710678 16.4246212 16.631728 17.131728 15.9246212 9.70710678 8.5 17.131728 1.0753788 16.4246212 0.368272016 9 7.79289322 1.5753788 0.368272016 0.868272016 1.0753788 8.29289322 8.5" />
              </g>
            </svg>
          </div>
          { calendarsArray }
        </div>

      </div>
    );
  }
}

Infobox.propTypes = {
  data: PropTypes.object.isRequired,
  selection: PropTypes.object.isRequired,
  selectionActions: PropTypes.object.isRequired,
  options: PropTypes.object.isRequired
};

export default Infobox;



/** WEBPACK FOOTER **
 ** ./src/components/Selection.js
 **/